import { render, staticRenderFns } from "./dyPacsimg_D.vue?vue&type=template&id=f064694a&scoped=true"
import script from "./dyPacsimg_D.vue?vue&type=script&lang=js"
export * from "./dyPacsimg_D.vue?vue&type=script&lang=js"
import style0 from "./dyPacsimg_D.vue?vue&type=style&index=0&id=f064694a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f064694a",
  null
  
)

export default component.exports